'use client'
import { ButtonRoundStyle, TextFieldCT } from '@/components'
import { Box, Button, Stack, Typography } from '@mui/material'
import { ReviewHeader } from './review-header'
import { CALLBACK_URL_KEY } from '@/constants'
import Link from 'next/link'

interface OrderInfoFormProps {
  orderCode: string
  setOrderCode: (value: string) => void
  onSubmit: () => void
  loading?: boolean
  errorMessage?: string
  isLoginRequired: boolean
}

export const OrderInfoForm = ({
  orderCode,
  setOrderCode,
  onSubmit,
  loading = false,
  errorMessage = '',
  isLoginRequired,
}: OrderInfoFormProps) => {
  return (
    <Stack spacing={2} sx={{ width: '100%', maxWidth: '520px ', alignItems: 'center' }}>
      {/* Header with Logo & Title */}
      <ReviewHeader
        note={
          <span>
            *Chỉ áp dụng cho đơn hàng mua tại{' '}
            <Typography component="span" sx={{ textDecoration: 'underline' }}>
              <Link href={'/'}>hydrashop.vn</Link>
            </Typography>
          </span>
        }
      />

      {/* Input Section */}
      <Box sx={{ width: '100%', mt: 3 }}>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 300,
            mb: 1,
          }}
        >
          Nhập mã đơn hàng của bạn:
        </Typography>
        <TextFieldCT
          fullWidth
          placeholder="VD: HYDRA000097"
          value={orderCode}
          onChange={(e) => setOrderCode(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && orderCode.trim() && !loading) {
              onSubmit()
            }
          }}
          disabled={loading}
          errorMessage={errorMessage}
          showLabel={false}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '99px',
              fontWeight: 300,
              '& fieldset': {
                borderColor: errorMessage ? '#F04438' : '#BBBBBA',
              },
            },
          }}
        />
      </Box>
      {isLoginRequired && (
        <ButtonRoundStyle
          size="small"
          variant="outlined"
          href={'/login?' + CALLBACK_URL_KEY + '=/accounts/feedback'}
          sx={{ fontSize: '0.875rem' }}
        >
          Đăng nhập ngay
        </ButtonRoundStyle>
      )}
      {/* Submit Button */}
      <ButtonRoundStyle
        variant="contained"
        loading={loading}
        size="large"
        onClick={onSubmit}
        disabled={!orderCode.trim() || loading}
        sx={{
          fontSize: '0.875rem',
          mt: 2,
        }}
      >
        Xác nhận mã đơn hàng
      </ButtonRoundStyle>
    </Stack>
  )
}
